const baseUrl = process.env.VUE_APP_API_ROOT;

let isSuperAdmin = false;

export default {
  adminAccessible(...steps: (string | number)[]) {
    const withPrefix = ((isSuperAdmin ? ['admin'] : []) as (
      | string
      | number
    )[]).concat(steps);

    return `${baseUrl}/${withPrefix.join('/')}`;
  },

  basic(...steps: string[]) {
    return `${baseUrl}/${steps.join('/')}`;
  },

  setSuperAdmin(superAdmin: boolean) {
    isSuperAdmin = superAdmin;
  }
};
